import React from "react";
import Breadcrumb from "../../components/Breadcrumb";

import aboutImg1 from "../../assets/img/about/about-4-1.jpg";
import aboutImg2 from "../../assets/img/about/about-4-2.jpg";
import shapeImg from "../../assets/img/about/shape-4-1.png";

const milestones = [
  { year: "2008", label: "Founded", desc: "Opened as Emergency Relief Center for earthquake victims" },
  { year: "2009", label: "Established", desc: "Officially registered as Maroof International Hospital" },
  { year: "Today", label: "Excellence", desc: "Leading provider of tertiary care across Pakistan" },
];

const values = [
  {
    icon: "flaticon-stethoscope",
    title: "Patient-Centered Care",
    desc: "Every decision is guided by unwavering commitment to patient health, safety, and privacy.",
  },
  {
    icon: "flaticon-first-aid",
    title: "Clinical Excellence",
    desc: "Board-certified, foreign-qualified doctors utilizing contemporary technology and state-of-the-art equipment.",
  },
  {
    icon: "flaticon-hospital",
    title: "Comprehensive Services",
    desc: "Modern invasive and non-invasive individualized treatments under one roof, available round the clock.",
  },
];

const OurStoryMain = ({ asSection = false }) => {
  const Tag = asSection ? "div" : "main";
  return (
    <Tag>
      {!asSection && <Breadcrumb title="Our Story" subTitle="Our Story" />}

      {/* ── Origin Story ────────────────────────────────────── */}
      <div className="it-about-area p-relative fix z-index pt-120 pb-80">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Images */}
            <div className="col-xl-5 col-lg-6 col-md-10 wow animate__fadeInLeft" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="p-relative" style={{ display: "flex", gap: "16px", alignItems: "stretch" }}>
                <div style={{ flex: 1, borderRadius: "12px", overflow: "hidden", minHeight: "420px" }}>
                  <img src={aboutImg1} alt="Maroof International Hospital" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ flex: 1, borderRadius: "12px", overflow: "hidden" }}>
                    <img src={aboutImg2} alt="Maroof Hospital Care" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                  <div
                    style={{
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
                      padding: "28px 20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    <span style={{ fontSize: "42px", fontWeight: 800, lineHeight: 1 }}>15+</span>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        marginTop: "6px",
                        opacity: 0.9,
                      }}
                    >
                      Years of
                      <br />
                      Excellence
                    </span>
                  </div>
                </div>
                <img
                  src={shapeImg}
                  alt=""
                  style={{ position: "absolute", bottom: "-20px", left: "-20px", width: "80px", opacity: 0.5, pointerEvents: "none" }}
                />
              </div>
            </div>

            {/* Text */}
            <div className="col-xl-7 col-lg-6 wow animate__fadeInRight" data-wow-duration=".9s" data-wow-delay=".5s">
              <div className="it-about-right" style={{ paddingLeft: "20px" }}>
                <div className="it-section-title-box mb-30">
                  <span className="it-section-subtitle green">Our Story</span>
                  <h2 className="it-section-title mb-20" style={{ fontSize: "38px", fontWeight: 800, lineHeight: 1.2 }}>
                    From Relief Center to <span style={{ color: "#1b74bb" }}>Leading Hospital</span>
                  </h2>
                </div>

                <p style={{ fontSize: "15px", lineHeight: 1.85, color: "#555", marginBottom: "18px" }}>
                  Since Pakistan&#39;s independence, our country had a handful of facilities offering quality care services, leaving a huge gap
                  behind for a population growing at an increasing rate of 1.9%. This gap presented a dire need for a new healthcare entrant
                  providing support in quality healthcare.
                </p>
                <p style={{ fontSize: "15px", lineHeight: 1.85, color: "#555", marginBottom: "18px" }}>
                  Seeing this exponential demand, we stepped in as an <strong>Emergency Relief Center in 2008</strong> — to share the burden of
                  the health sector and offer help to the deluge of earthquake victims.
                </p>
                <p style={{ fontSize: "15px", lineHeight: 1.85, color: "#555", marginBottom: "30px" }}>
                  Through endless efforts of staying committed to provide the best care to society, we became the ideal choice for residents of
                  the twin cities, across Pakistan and further afield. In <strong>April 2009</strong>, Maroof International Hospital was
                  formally established as a known entity — made attainable only by the vigilant efforts of our clinical and non-clinical teams.
                </p>

                <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#e8f1fb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="flaticon-check" style={{ color: "#1b74bb", fontSize: "16px" }} />
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>24/7 Tertiary Care</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#e8f1fb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="flaticon-check" style={{ color: "#1b74bb", fontSize: "16px" }} />
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>International Standard OTs</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#e8f1fb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="flaticon-check" style={{ color: "#1b74bb", fontSize: "16px" }} />
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Special Care Units</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#e8f1fb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="flaticon-check" style={{ color: "#1b74bb", fontSize: "16px" }} />
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>Board-Certified Specialists</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Timeline ─────────────────────────────────────────── */}
      <div style={{ background: "#f7f9fc", padding: "80px 0" }}>
        <div className="container">
          <div className="row justify-content-center mb-50">
            <div className="col-xl-6 text-center">
              <span className="it-section-subtitle green">Our Journey</span>
              <h2 className="it-section-title" style={{ fontSize: "34px", fontWeight: 800 }}>
                Milestones That Define Us
              </h2>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {milestones.map((m, i) => (
              <div
                key={i}
                className="col-xl-4 col-lg-4 col-md-6 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={`${0.2 + i * 0.2}s`}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "40px 32px",
                    textAlign: "center",
                    height: "100%",
                    boxShadow: "0 4px 24px rgba(27,116,187,0.08)",
                    borderTop: "4px solid #1b74bb",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      fontSize: "48px",
                      fontWeight: 900,
                      color: "#1b74bb",
                      lineHeight: 1,
                      marginBottom: "12px",
                    }}
                  >
                    {m.year}
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: 700, marginBottom: "10px", color: "#1a1a2e" }}>{m.label}</h4>
                  <p style={{ fontSize: "14px", color: "#666", lineHeight: 1.7, margin: 0 }}>{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Core Values ──────────────────────────────────────── */}
      <div style={{ padding: "80px 0 100px" }}>
        <div className="container">
          <div className="row justify-content-center mb-50">
            <div className="col-xl-6 text-center">
              <span className="it-section-subtitle green">What Drives Us</span>
              <h2 className="it-section-title" style={{ fontSize: "34px", fontWeight: 800 }}>
                Our Core Commitments
              </h2>
              <p style={{ color: "#666", marginTop: "12px", fontSize: "15px" }}>
                We never compromised on patient health, safety and privacy — and we never will.
              </p>
            </div>
          </div>
          <div className="row g-4">
            {values.map((v, i) => (
              <div
                key={i}
                className="col-xl-4 col-lg-4 col-md-6 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={`${0.2 + i * 0.2}s`}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    padding: "40px 32px",
                    height: "100%",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                    border: "1px solid #eef2f7",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #e8f1fb 0%, #d0e4f7 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <i className={v.icon} style={{ fontSize: "28px", color: "#1b74bb" }} />
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px", color: "#1a1a2e" }}>{v.title}</h4>
                  <p style={{ fontSize: "14px", color: "#666", lineHeight: 1.75, margin: 0 }}>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Full Story Quote ─────────────────────────────────── */}
      <div
        style={{
          background: "linear-gradient(135deg, #1b74bb 0%, #0d4f8a 100%)",
          padding: "80px 0",
          marginBottom: "0",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10 text-center">
              <i
                className="fa-solid fa-quote-left"
                style={{ fontSize: "40px", color: "rgba(255,255,255,0.3)", marginBottom: "20px", display: "block" }}
              />
              <p
                style={{
                  fontSize: "20px",
                  lineHeight: 1.8,
                  color: "#fff",
                  fontStyle: "italic",
                  fontWeight: 400,
                  marginBottom: "32px",
                }}
              >
                To date, we never compromised on the patient&#39;s health, safety and privacy. Our experienced and compassionate team of
                foreign-qualified and board-certified doctors are skillful enough to use contemporary technology and state-of-the-art equipment
                for the finest outcomes.
              </p>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "48px", height: "2px", background: "rgba(255,255,255,0.5)" }} />
                <span
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: 700,
                    fontSize: "14px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                  }}
                >
                  Maroof International Hospital
                </span>
                <div style={{ width: "48px", height: "2px", background: "rgba(255,255,255,0.5)" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Tag>
  );
};

export default OurStoryMain;
